import React from 'react';
import {connect} from 'dva';
import {withRouter} from 'dva/router';
import {ConfigProvider} from 'antd';
import routers from './../router-config';
import pathToRegexp from 'path-to-regexp'
import classNames from 'classnames'
import UserMenu from "../components/user-menu";
import esEs from 'antd/es/locale/es_ES'
import zhCN from 'antd/es/locale/zh_CN';
import enUS from 'antd/es/locale/en_US';
import de_DE from 'antd/es/locale/de_DE';
import fr_FR from 'antd/es/locale/fr_FR';
import ar_SA from 'antd/es/locale/ar_EG';
import ru_RU from 'antd/es/locale/ru_RU';
import ms_MY from 'antd/es/locale/ms_MY';
import vi_VN from 'antd/es/locale/vi_VN';
import th_TH from 'antd/es/locale/th_TH';
import id_ID from 'antd/es/locale/id_ID';


// 多语言
const messages = {
    // 'en': enUS,
    'zh': zhCN,
    'es': esEs,
    'en': enUS,
    'de': de_DE,
    'fr': fr_FR,
    'ar': ar_SA,
    'ru': ru_RU,
    'ms': ms_MY,
    'vi': vi_VN,
    'th': th_TH,
    'id': id_ID,

};

class PageLayout extends React.Component {
    componentDidMount() {
        this.resetScrollTop();
    }

    componentDidUpdate(prevProps) {
        if (this.getRouteKey(prevProps.location) !== this.getRouteKey(this.props.location)) {
            this.resetScrollTop();
        }
    }

    getRouteKey = (location = {}) => {
        return `${location.pathname || ''}${location.search || ''}${location.hash || ''}`;
    };

    resetScrollTop = () => {
        document.body.scrollTop = 0;
    };

    render() {
        const {appModel, children, dispatch, location: {pathname}, history} = this.props;
        // 获取页面设置
        const page = (routers || []).find(router => pathToRegexp(router.path).exec(pathname)) || {};
        const cls = classNames('page-body', {'page-max': page.layoutMax});
        const {lang = 'zh'} = appModel;
        return (
            <ConfigProvider locale={messages[lang]}>
                <div className={cls}>
                    {
                        page.showMenu &&
                        <UserMenu pathname={pathname} history={history} dispatch={dispatch}/>
                    }
                    <div className="page-main">{children}</div>
                </div>
            </ConfigProvider>
        );
    }
}

const mapStateToProps = (state) => {
    return {...state}
};
export default withRouter(connect(mapStateToProps)(PageLayout));
